import React, { lazy } from 'react';
import { Download, Shield, Zap, CheckCircle } from 'lucide-react';
import { useGeoPrice } from '../../hooks/useGeoPrice';
export function OfferSection() {
  const {
    price,
    loading
  } = useGeoPrice();
  return <section id="oferta" className="py-8 px-4" style={{
    backgroundColor: '#000000'
  }} data-id="element-182">
      <div className="w-full mb-6" style={{
      height: '2px',
      background: 'linear-gradient(90deg, transparent, #c0392b, transparent)'
    }} data-id="element-183" />

      <div className="max-w-2xl mx-auto text-center" data-id="element-184">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase mb-6" style={{
        backgroundColor: 'rgba(192,57,43,0.15)',
        border: '1px solid #c0392b',
        color: '#c0392b'
      }} data-id="element-185">
          <Zap size={12} data-id="element-186" /> OFERTA ESPECIAL · TIEMPO LIMITADO
        </div>

        {/* Product mockup */}
        <div className="flex justify-center mb-5" data-id="element-187">
          <img src="https://cdn.magicpatterns.com/uploads/eGG89Tvm3mKXz7KkAtpvwB/ChatGPT_Image_21_nov_2025_00_47_41.webp" alt="Evidencia real - casos confidenciales" className="w-full max-w-xs rounded-xl shadow-2xl" loading="lazy" data-id="element-188" />
        </div>

        {/* Title */}
        <h2 className="text-3xl sm:text-4xl font-black text-white mb-4 leading-tight" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-189">
          SOLO HOY:{' '}
          <span style={{
          color: '#c0392b'
        }} data-id="element-190">
            4x1
          </span>{' '}
          EN MISTERIOS
        </h2>

        {/* Description */}
        <p className="text-gray-300 text-base leading-relaxed mb-4 max-w-lg mx-auto" data-id="element-191">
          Recibe <strong className="text-white" data-id="element-192">4 casos al precio de 1</strong>.
          Son 4 misterios sin resolver para tu ingenio y el de tus amigos. Cada
          expediente está lleno de pistas, documentos y evidencias que te harán
          pensar.
        </p>

        {/* Price */}
        <div className="flex items-center justify-center gap-4 mb-5" data-id="element-193">
          {loading ? <div className="h-16 w-48 rounded animate-pulse bg-gray-800" data-id="element-194" /> : <>
              <div className="text-center" data-id="element-195">
                <span className="text-gray-500 line-through text-xl block" data-id="element-196">
                  {price.compareAt} {price.currency}
                </span>
                <span className="text-xs text-gray-600" data-id="element-197">Precio normal</span>
              </div>
              <div className="text-5xl font-black" style={{
            color: '#f0c040',
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-198">
                {price.current} {price.currency}
              </div>
              <div className="px-3 py-2 rounded text-sm font-black text-white" style={{
            backgroundColor: '#c0392b'
          }} data-id="element-199">
                {price.discount}
                <br data-id="element-200" />
                <span className="text-xs font-normal" data-id="element-201">DESCUENTO</span>
              </div>
            </>}
        </div>

        {/* CTA */}
        <a href="https://www.resuelvecasos.online/cart/47736555077876:1" target="_blank" rel="noopener noreferrer" onClick={() => {
        ;
        (window as any).fbq?.('track', 'AddToCart');
      }} className="w-full sm:w-auto flex items-center justify-center gap-3 px-10 py-5 text-xl font-black text-white rounded-lg transition-all hover:opacity-90 active:scale-95 mx-auto" style={{
        backgroundColor: '#c0392b',
        boxShadow: '0 0 40px rgba(192,57,43,0.5)',
        letterSpacing: '0.03em'
      }} data-id="element-202">
          <Download size={24} data-id="element-203" />
          🔍 DESCARGAR CASOS AHORA
        </a>

        {/* Trust row */}
        <div className="flex flex-wrap justify-center gap-4 mt-5 text-sm text-gray-400" data-id="element-204">
          <span className="flex items-center gap-1" data-id="element-205">
            <CheckCircle size={14} style={{
            color: '#27ae60'
          }} data-id="element-206" />{' '}
            Acceso inmediato
          </span>
          <span className="flex items-center gap-1" data-id="element-207">
            <Shield size={14} style={{
            color: '#27ae60'
          }} data-id="element-208" />{' '}
            Garantía 30 días
          </span>
          <span className="flex items-center gap-1" data-id="element-209">
            <CheckCircle size={14} style={{
            color: '#27ae60'
          }} data-id="element-210" />{' '}
            Pago seguro
          </span>
        </div>
      </div>

      <div className="w-full mt-6" style={{
      height: '2px',
      background: 'linear-gradient(90deg, transparent, #c0392b, transparent)'
    }} data-id="element-211" />
    </section>;
}